import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EditableText } from "@/context/ContentContext";
import { api } from "@/lib/api";
import { CONTACT } from "@/data/site";

export default function Contatti() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato. Ti rispondo direttamente, senza autorisponditori.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Qualcosa non ha funzionato. Riprova o scrivimi via email.");
    } finally {
      setSending(false);
    }
  };
  const inputCls = "w-full bg-transparent border-b border-darkgrey/50 py-3 font-body text-lg focus:outline-none focus:border-ink placeholder:text-darkgrey/60";
  return (
    <div data-testid="contatti-page" className="pt-32 md:pt-44 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-16">
        <Reveal>
          <EditableText k="contatti_eyebrow" as="p" className="font-mono2 uppercase tracking-widest text-darkgrey mb-6" />
          <EditableText k="contatti_title" as="h1" className="font-heading leading-[0.95]" />
          <div className="mt-12 space-y-8">
            <div>
              <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-2">Email</p>
              <a href={`mailto:${CONTACT.email}`} className="font-heading text-2xl md:text-3xl link-underline">{CONTACT.email}</a>
            </div>
            <div>
              <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-2">Telefono</p>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="font-heading text-2xl md:text-3xl link-underline">{CONTACT.phone}</a>
            </div>
            <div>
              <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey mb-2">Instagram</p>
              <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="font-heading text-2xl md:text-3xl link-underline">{CONTACT.instagram}</a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <form onSubmit={submit} data-testid="contact-form" className="space-y-10 md:mt-20">
            <input data-testid="contact-name" required placeholder="Nome" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
            <input data-testid="contact-email" type="email" required placeholder="Email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
            <textarea data-testid="contact-message" required rows={4} placeholder="Di cosa hai bisogno? Sii specifico." value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })} className={inputCls + " resize-none"} />
            <button data-testid="contact-submit" disabled={sending}
              className="inline-flex items-center gap-3 border border-ink text-ink px-8 py-4 uppercase text-xs tracking-widest hover:bg-ink hover:text-greige transition-colors disabled:opacity-50">
              {sending ? "Invio…" : "Invia"} <ArrowRight size={16} />
            </button>
            <p className="font-mono2 text-[11px] text-darkgrey leading-relaxed">
              Inviando accetti il trattamento dei dati secondo la Privacy Policy. {/* IUBENDA PLACEHOLDER: link/checkbox consenso */}
            </p>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
